import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { AppBar, Button, CardContent, Checkbox, colors, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, Switch, Tab, Tabs, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import api from '../../../services/api';
import { ANAO, ASIM, ATIPO_VENDEDOR_ESPECIFICO } from 'consts';
import ComboPadrao from 'views/Components/ComboPadrao';
import { formatDateForInput } from 'lib/functions';
import { getConfigField } from 'lib/configUtils';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import ComissaoVendedorServico from './ComissaoVendedorServico';

function TabContainer(props) {
    return (
        <Typography
            component="div"
        // style={{ padding: 8 * 3 }}
        >
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

// Definição dos estilos
const styles = theme => ({
    // textField: {
    //     marginTop: theme.spacing(0), // Margem superior
    //     marginBottom: "0.5rem", // Margem inferior
    //     marginRight: "0.5rem", // Margem direita
    // },
    // addButton: {
    //     height: '42px',
    //     display: 'flex',
    //     alignItems: 'center',
    //     float: 'right', // alinhamento a direita
    // },
    // textarea: {
    //     width: '100%',
    //     height: '100px',
    //     padding: theme.spacing(1),
    //     boxSizing: 'border-box',
    // },
    // dialogContent: {
    //     padding: theme.spacing(2),
    // },
});

class VendedorForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vendedor: {},
            funcionarios: [],
            clientes: [],
            fornecedores: [],
            usuarios: [],
            comissaoservicos: [],
            activetab: 0,
            isNewRecord: false,
            isView: false
        };
    }

    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;

        // campos configurações
        const possibvincvendedorcliente = (getConfigField('possibvincvendedorcliente') == ASIM);
        const vincvendexternoafornec = (getConfigField('vincvendexternoafornec') == ASIM);

        if (id >= 0) {
            const response = await api.get(`/vendedor/${id}`);

            this.setState({
                vendedor: response.data.data[0],
                activeTab: '1',
                isNewRecord: false,
                isView: (currentPath.includes('/view'))
            });

            const { vendedor } = this.state;
            vendedor.datanasc = formatDateForInput(vendedor.datanasc);
            this.setState({ vendedor: vendedor });

            const funcionarios = await api.get(`/funcionario/listforchange/${response.data.data[0].codfuncionario}`);
            this.setState({ funcionarios: funcionarios.data.data });

            if (possibvincvendedorcliente) {
                const clientes = await api.get(`/cliente/listforchange/${response.data.data[0].codcliente}`);
                this.setState({ clientes: clientes.data });
            }

            if (vincvendexternoafornec) {
                const fornecedores = await api.get(`/fornecedor/listforchange/${response.data.data[0].codfornecedor}`);
                this.setState({ fornecedores: fornecedores.data });

                const usuarios = await api.get(`/usuario/listforchange/${response.data.data[0].codusuario}`);
                this.setState({ usuarios: usuarios.data.data });
            }
        }
        else if (id === 'novo') {
            this.setState({
                activeTab: '1',
                isNewRecord: true
            });

            const funcionarios = await api.get(`/funcionario/active/true`);
            this.setState({ funcionarios: funcionarios.data.data });

            if (possibvincvendedorcliente) {
                const clientes = await api.get(`/cliente/active/true`);
                this.setState({ clientes: clientes.data });
            }

            if (vincvendexternoafornec) {
                const fornecedores = await api.get(`/fornecedor/active/true`);
                this.setState({ fornecedores: fornecedores.data });

                const usuarios = await api.get(`/usuario/active/true`);
                this.setState({ usuarios: usuarios.data.data });
            }
        }
    }

    /* evento on change componentes */
    OnChange = (event) => {
        const { vendedor } = this.state;
        const { name, type, value, checked } = event.target;
        let adjustedValue = value; // Valor ajustado com base no tipo do input

        // Decide o tratamento com base no tipo do input ou nome
        switch (type) {
            case 'checkbox':
                // Usa o valor checked para campos do tipo checkbox
                // Tratamentos adicionais específicos para campos
                if (name === 'inativo') {
                    if (checked === false) {
                        adjustedValue = ASIM;
                    }
                    else {
                        adjustedValue = ANAO;
                    }
                }
                else {
                    if (checked === false) {
                        adjustedValue = ANAO;
                    } else {
                        adjustedValue = ASIM;
                    }
                }

                if (name == 'vendedorexterno') {
                    if (checked === false) {
                        vendedor.codcliente = 0;
                        vendedor.codfornecedor = 0;
                        vendedor.codusuario = 0;
                    }
                }

                break;
            case 'select-one':
                adjustedValue = Number(value);
                break;
            case 'radio':
                adjustedValue = Number(value);
                break;
            case 'textarea':
                break;
            default:
                if ((name == 'foneresidencial') || (name == 'fonecelular')) {
                    adjustedValue = value.replace(/[a-zA-Z]/g, '')
                } else if (!((name == 'email'))) {
                    adjustedValue = value.toUpperCase();
                }
                break;
        }

        // Atualiza o estado com o valor ajustado
        vendedor[name] = adjustedValue;
        this.setState({ vendedor: vendedor });
    }

    handleChangeTab = (event, value) => {
        this.setState({ activetab: value });
    };

    /* Click salvar */
    onClickSave = () => {
        if (this.validationRequiredFields()) {
            if (this.state.isNewRecord) {
                this.insereVendedor()
            }
            else {
                this.atualizaVendedor();
            }
        }
    }

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/front/vendedores');
    }

    /* valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { vendedor } = this.state;
        let retorno = true;

        if ((String(vendedor.nomevendedor).trim() === '') || (vendedor.nomevendedor === undefined)) {
            vendedor.nomevendedor = '';
            this.setState({ vendedor: vendedor });
            retorno = false;
        }

        return retorno;
    };

    /* insere novo vendedor */
    insereVendedor = async () => {
        const { vendedor } = this.state;

        /* monta lista de comissão de serviços */
        const { comissaoservicos } = this.state;
        if (comissaoservicos.length > 0) {
            let comissaoservico = [];
            for (let i = 0; i <= comissaoservicos.length - 1; i++) {
                if ((comissaoservicos[i].perccomissao > 0) || (comissaoservicos[i].valorporpax > 0) ||
                    (comissaoservicos[i].valorporpaxchd > 0) || (comissaoservicos[i].valorporpaxinf > 0) ||
                    (comissaoservicos[i].valorporpaxsen > 0)) {
                    comissaoservico.push({
                        codservico: comissaoservicos[i].codservico,
                        perccomissao: comissaoservicos[i].perccomissao,
                        valorporpax: comissaoservicos[i].valorporpax,
                        valorporpaxchd: comissaoservicos[i].valorporpaxchd,
                        valorporpaxinf: comissaoservicos[i].valorporpaxinf,
                        valorporpaxsen: comissaoservicos[i].valorporpaxsen,
                        // calculacomissobreliquido: comissoes[i].calculacomissobreliquido
                    });
                }
            }

            vendedor['comissaoservicos'] = comissaoservico;
        }

        try {
            const response = await api.post(`/vendedor`, vendedor);
            if (response.status === 200) {
                this.props.history.push('/front/vendedores');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    /* atualiza dados de vendedor existente - post */
    atualizaVendedor = async () => {
        const { vendedor } = this.state;

        try {
            const response = await api.put(`/vendedor/${vendedor.codvendedor}`, vendedor);
            if (response.status === 200) {
                this.props.history.push('/front/vendedores');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* abre janela de comissão serviço */
    handleOpenComissaoServico = () => {
        this.setState({ openComissaoServico: true });
    };

    /* fecha janela de comissão serviço */
    handleCloseComissaoServico = () => {
        this.setState({ openComissaoServico: false });
    }

    /* Método para atualizar a lista de comissão de serviços */
    updateComissaoServicos = async (comissaoServicos) => {
        this.setState({ comissaoservicos: comissaoServicos });
    };

    render() {
        const { classes } = this.props;

        const { vendedor, activetab, funcionarios, clientes, fornecedores, usuarios } = this.state;

        // campos configurações
        const calculacomissdedcusto = (getConfigField('calculacomissdedcusto') == ASIM);
        const tipovenddedcustocomiss = getConfigField('tipovenddedcustocomiss');
        const possibvincvendedorcliente = (getConfigField('possibvincvendedorcliente') == ASIM);
        const vincvendexternoafornec = (getConfigField('vincvendexternoafornec') == ASIM);

        return (
            <div>
                <AppBar
                    color="default"
                    position="static"
                >
                    <Tabs
                        indicatorColor="primary"
                        onChange={this.handleChangeTab}
                        scrollButtons="auto"
                        scrollable
                        variant="scrollable"
                        textColor="primary"
                        value={activetab}
                    >
                        <Tab
                            label="Dados"
                        />

                        <Tab
                            style={{ display: 'none' }}
                            label="Empresa"
                        />
                    </Tabs>
                </AppBar>

                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                    >
                        Vendedor {vendedor.codvendedor} - {vendedor.nomevendedor}
                    </Typography>

                    {/* Aba Dados */}
                    {activetab === 0 &&
                        <TabContainer>
                            <FormGroup>
                                <TextField
                                    // className={this.state.useStyles.textField}
                                    label="Nome"
                                    style={{ marginTop: 10 }}
                                    name="nomevendedor"
                                    value={vendedor.nomevendedor || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    helperText={vendedor.nomevendedor === '' ? 'Nome do vendedor obrigatório' : ' '}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 100 }}
                                />
                            </FormGroup>

                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={!(vendedor.inativo === ASIM)}
                                        name="inativo"
                                        onChange={this.OnChange}
                                        color="primary"
                                        disabled={this.state.isView}
                                    />
                                }
                                label={(vendedor.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                            />

                            <br />
                            <br />

                            <FormControl
                                fullWidth
                                variant="outlined"
                                disabled={this.state.isView || (vendedor.vendedorexterno == ASIM)}
                            >
                                <ComboPadrao
                                    name={'codfuncionario'}
                                    label={'Funcionário'}
                                    value={vendedor.codfuncionario}
                                    onChange={this.OnChange}
                                    fieldId={'codfuncionario'}
                                    listItems={funcionarios}
                                    fieldDescription={'nome'}
                                />
                            </FormControl>

                            <br />
                            <br />

                            <FormGroup row>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label="Data de nascimento"
                                    name="datanasc"
                                    onChange={this.OnChange}
                                    type="date"
                                    value={vendedor.datanasc || ''}
                                    variant="outlined"
                                    disabled={this.state.isView}
                                    style={{ marginRight: 20 }}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(vendedor.vendedorexterno === ASIM)}
                                            name="vendedorexterno"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Vendedor externo'}
                                />

                                {calculacomissdedcusto && (tipovenddedcustocomiss === ATIPO_VENDEDOR_ESPECIFICO) &&
                                    (<FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(vendedor.calccomissdedcusto === ASIM)}
                                                name="calccomissdedcusto"
                                                onChange={this.OnChange}
                                                color="primary"
                                                disabled={this.state.isView}
                                            />}
                                        label={'Calcula comissão deduzindo custo'}
                                    />)
                                }

                                <Button
                                    color="primary"
                                    style={{
                                        backgroundColor: colors.grey[300],
                                        color: 'black',
                                        marginTop: '5px',
                                        height: 40,
                                        // display: 'none'
                                    }}
                                    variant="contained"
                                    onClick={this.handleOpenComissaoServico}
                                    disabled={this.state.isView}
                                >
                                    % Comissão serviço
                                </Button>
                            </FormGroup>

                            <FormGroup row>
                                <TextField
                                    label="Fone residencial"
                                    name="foneresidencial"
                                    value={vendedor.foneresidencial || ''}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 20 }}
                                    style={{ marginRight: 10 }}
                                />

                                <TextField
                                    label="Fone celular"
                                    name="fonecelular"
                                    value={vendedor.fonecelular || ''}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 20 }}
                                    style={{ marginRight: 10 }}
                                />

                                <TextField
                                    label="E-mail"
                                    name="email"
                                    value={vendedor.email || ''}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 100 }}
                                    style={{ width: 500 }}
                                />
                            </FormGroup>

                            {possibvincvendedorcliente && (vendedor.vendedorexterno == ASIM) &&
                                (<FormControl
                                    fullWidth
                                    variant="outlined"
                                    disabled={this.state.isView}
                                    margin="normal"
                                >
                                    <ComboPadrao
                                        name={'codcliente'}
                                        label={'Cliente'}
                                        value={vendedor.codcliente}
                                        onChange={this.OnChange}
                                        fieldId={'codcliente'}
                                        listItems={clientes}
                                        fieldDescription={'fantasia'}
                                    />
                                </FormControl>)
                            }

                            {vincvendexternoafornec && (vendedor.vendedorexterno == ASIM) &&
                                (<FormControl
                                    fullWidth
                                    variant="outlined"
                                    disabled={this.state.isView}
                                    margin="normal"
                                >
                                    <ComboPadrao
                                        name={'codfornecedor'}
                                        label={'Fornecedor'}
                                        value={vendedor.codfornecedor}
                                        onChange={this.OnChange}
                                        fieldId={'codfornecedor'}
                                        listItems={fornecedores}
                                        fieldDescription={'fantasia'}
                                    />
                                </FormControl>)
                            }

                            {vincvendexternoafornec && (vendedor.vendedorexterno == ASIM) &&
                                (<FormControl
                                    fullWidth
                                    variant="outlined"
                                    disabled={this.state.isView}
                                    margin="normal"
                                >
                                    <ComboPadrao
                                        name={'codusuario'}
                                        label={'Usuário'}
                                        value={vendedor.codusuario}
                                        onChange={this.OnChange}
                                        fieldId={'codusuario'}
                                        listItems={usuarios}
                                        fieldDescription={'usuario'}
                                    />
                                </FormControl>)
                            }
                        </TabContainer>
                    }

                    <Button
                        name="salvar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickSave}
                        style={{ marginTop: '10px' }}
                        disabled={this.state.isView}
                    >
                        Salvar
                    </Button>

                    <Button
                        name="cancelar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickCancel}
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                    >
                        Cancelar
                    </Button>
                </CardContent>

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />

                {/* Comissão serviço */}
                <Dialog open={this.state.openComissaoServico} onClose={this.handleCloseComissaoServico} maxWidth="bg" fullWidth>
                    <DialogTitle className={classes.dialogTitle}>Comissão por serviço</DialogTitle>
                    <DialogContent className={classes.dialogContent}>
                        <ComissaoVendedorServico
                            codVendedor={vendedor.codvendedor}
                            comissaoServicos={this.state.comissaoservicos}
                            onSave={(updateComissao) => {
                                this.handleCloseComissaoServico();
                                this.updateComissaoServicos(updateComissao);
                            }}
                            onClose={this.handleCloseComissaoServico}
                        />
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

VendedorForm.propTypes =
{
    classes: PropTypes.object.isRequired
};

//export default VendedorForm;
export default withStyles(styles)(VendedorForm);